module.exports = __webpack_public_path__ + "p5_img1.png?d4e390641533ca997244f6d6fa553f96";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p5/p5_img1.png
// module id = 56
// module chunks = 0